import qs from 'qs';
export var getQuery = function (url, props) {
    var urlArr = url.split('?');
    var params = urlArr && urlArr.length > 1 ? urlArr[1] : '';
    var parsed = qs.parse(params) || {};
    return parsed;
};
export var processQuery = function (url, params) {
    var urlArr = url.split('?');
    var baseUrl = urlArr && urlArr[0];
    var query = qs.stringify(params);
    return "".concat(baseUrl, "?").concat(query);
};
